"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*globals Kobo, resources*/
(function () {
  Kobo.Utilities.assignToNamespace('Kobo.Enums.ProductFormat', Kobo.Enum.define({
    PDF: ['PDF', 2],
    EPUB2: ['EPUB2', 5],
    EPUB3: ['EPUB3', 10],
    Unknown: ['Unknown', 99]
  }));

  var ProductFormatExtensions = /*#__PURE__*/function () {
    function ProductFormatExtensions() {
      _classCallCheck(this, ProductFormatExtensions);
    }

    _createClass(ProductFormatExtensions, null, [{
      key: "mapToResourceString",
      value: function mapToResourceString(productFormat) {
        var _map;

        var ProductFormat = Kobo.Enums.ProductFormat,
            resourceStrings = resources.getString('productFormat');
        var map = (_map = {}, _defineProperty(_map, ProductFormat.EPUB2, resourceStrings.epub2), _defineProperty(_map, ProductFormat.EPUB3, resourceStrings.epub3), _defineProperty(_map, ProductFormat.PDF, resourceStrings.pdf), _map);
        return map[productFormat] || '';
      }
    }]);

    return ProductFormatExtensions;
  }();

  Kobo.Utilities.assignToNamespace('Kobo.Enums.ProductFormat.Extensions', ProductFormatExtensions);
})();